// import Vue from 'vue';
import request from '@/utils/request';
import router from '@/router';

const baseURL = process.env.VUE_APP_API;

export const fetch = (url, opts = {}) => {
  return request({
    url: url,
    baseURL: baseURL,
    method: opts.method,
    headers: {
      Authorization: localStorage.getItem('apitoken') || '',
      ...opts.header,
    },
    params: {
      // timestamp: new Date().getTime(),
      ...(opts.query || {}),
    },
    data: opts.body,
  })
    .then(res => {
      return Promise.resolve(res);
    })
    .catch(([err]) => {
      // 断网处理
      // const redirectUri = `/error/offline?redirect_k_uri=${encodeURIComponent(window.location.href)}`;
      // 断网状态查看计数
      // let checkCount = 20;
      // 断网状态查看函数
      // const checkisOnLine = () => {
      //   if (checkCount <= 0) {
      //     return;
      //   }
      //   if (!window.navigator.onLine) {
      //     return router.replace(redirectUri);
      //   }
      //   checkCount--;
      //   setTimeout(() => {
      //     checkisOnLine();
      //   }, 50);
      // };
      // 是否执行断网状态查看函数
      // if (!opts.notCheckOnLine) {
      // 执行断网状态查看函数
      //   checkisOnLine();
      // }

      // 是否请求错误提示
      if (!opts.hideToast) {
        // Vue.$vux.toast.text(err.message, 'top');
      }
      console.log('!!!!!!!!!!', err);
      // 根据code进行后续处理
      switch (err.code || 404) {
        case 400: {
          console.log('RES STATUS: ', 400, '用户发出的请求有错误，服务器没有进行新建或修改数据的操作');
          break;
        }
        case 16: {
          localStorage.removeItem('apitoken');
          router.replace('/');
          // 请重新登录
          console.log('RES STATUS: ', 401, '表示用户没有权限（令牌、用户名、密码错误）, 请重新登录');
          break;
        }
        case 402: {
          console.log('RES STATUS: ', 402, '余额不足的特例(请在使用该方法前认真看实现');
          break;
        }
        case 403: {
          console.log('RES STATUS: ', 403, '表示用户得到授权（与401错误相对），但是访问是被禁止的');
          break;
        }
        case 404: {
          console.log('RES STATUS: ', 404, '用户发出的请求针对的是不存在的记录，服务器没有进行操作');
          // router.replace('/error/404');
          break;
        }
        case 406: {
          console.log('RES STATUS: ', 406);
          break;
        }
        case 410: {
          console.log('RES STATUS: ', 410, '用户请求的资源被永久删除，且不会再得到的');
          break;
        }
        case 422: {
          console.log('RES STATUS: ', 422, '当创建一个对象时，发生一个验证错误');
          break;
        }
        case 500: {
          console.log('RES STATUS: ', 500, '服务器发生错误，用户将无法判断发出的请求是否成功');
          break;
        }
        default:
          break;
      }
      return Promise.resolve(err);
    });
};

export default {
  get: (url, opts = {}) =>
    fetch(url, {
      method: 'GET',
      ...opts,
    }),
  put: (url, opts = {}) =>
    fetch(url, {
      method: 'PUT',
      ...opts,
    }),
  post: (url, opts = {}) =>
    fetch(url, {
      method: 'POST',
      ...opts,
    }),
  patch: (url, opts = {}) =>
    fetch(url, {
      method: 'PATCH',
      ...opts,
    }),
  delete: (url, opts = {}) =>
    fetch(url, {
      method: 'DELETE',
      ...opts,
    }),
};
